"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBarOuter = exports.ProgressBarHidden = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _context = require("../context");

var ProgressBarHidden = ( /*#__PURE__*/0, _styledBase.default)('progress', {
  target: "e190djw50"
})(function () {
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    minWidth: '100%'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3Byb2dyZXNzLWJhci9oZWxwZXJDb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJaUMiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL3N1Ym1vZHVsZXMvcHJvZ3Jlc3MtYmFyL2hlbHBlckNvbXBvbmVudHMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBzdHlsZWRXaXRoVGhlbWUgfSBmcm9tICcuLi9jb250ZXh0JztcblxuZXhwb3J0IGNvbnN0IFByb2dyZXNzQmFySGlkZGVuID0gc3R5bGVkKCdwcm9ncmVzcycpKCgpID0+ICh7XG4gIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICB0b3A6IDAsXG4gIGxlZnQ6IDAsXG4gIG9wYWNpdHk6IDAsXG4gIG1pbldpZHRoOiAnMTAwJSdcbn0pKTtcblxuZXhwb3J0IGNvbnN0IFByb2dyZXNzQmFyT3V0ZXIgPSBzdHlsZWRXaXRoVGhlbWUoJ2RpdicpKCgpID0+ICh7XG4gIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICBkaXNwbGF5OiAnZmxleCcsXG4gIGZsZXhEaXJlY3Rpb246ICdjb2x1bW4nLFxuICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgd2lkdGg6ICcxMDAlJ1xufSkpO1xuIl19 */");
exports.ProgressBarHidden = ProgressBarHidden;
var ProgressBarOuter = (0, _context.styledWithTheme)('div')(function () {
  return {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  };
});
exports.ProgressBarOuter = ProgressBarOuter;